export const iconFontAwesomeSpinnersSun = (
	<i className="fa-solid fa-sun"></i>
);
